// extracted by mini-css-extract-plugin
export default {"options":"display-prognosis-selection-options-X53R6Y","container":"display-prognosis-selection-container-uOTQjt","checkbox":"display-prognosis-selection-checkbox-WT5acK"};